// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/.pnpm/css-loader@4.3.0_webpack@4.46.0/node_modules/css-loader/dist/cjs.js??ref--5-oneOf-1-1!../../../../node_modules/.pnpm/postcss-loader@4.3.0_postcss@8.5.8_webpack@4.46.0/node_modules/postcss-loader/dist/cjs.js??ref--5-oneOf-1-2!./icons.module.css");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../node_modules/.pnpm/vue-style-loader@4.1.3/node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("e4324278", content, true, {"sourceMap":false});